import { Component, Inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { FarmerService } from "src/app/services/farmer.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AlertService } from "src/app/services/alert.service";
import { Router } from "@angular/router";
import { EventType } from "src/enum/eventtype";
import * as moment from "moment";
@Component({
  selector: "app-exemptionpopup",
  templateUrl: "./exemptionpopup.component.html",
  styleUrls: ["./exemptionpopup.component.scss"],
})
export class ExemptionpopupComponent implements OnInit {
  delayTypeList: any[];
  delayType: any;
  form: FormGroup;
  public eventEnum = EventType;
  minDate:any;
  maxDate:any

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private farmerService: FarmerService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private router: Router,
    public dialogRef: MatDialogRef<ExemptionpopupComponent>
  ) {}

  ngOnInit(): void {
    this.minDate = new Date();
   this.maxDate= new Date(
    moment(new Date()).add(1, "day").format("YYYY, MM, DD")
  );
    this.initializeValidators();
    this.getdeliveryDelayType();
  }
  getdeliveryDelayType() {
    this.farmerService.getdeliveryDelayType(true).subscribe((res) => {
      this.delayTypeList = [];
      this.delayType = res.filter((i: { key: number }) => i.key);
      this.delayTypeList = this.delayType;
    });
  }
  initializeValidators() {
    this.form = this.formBuilder.group({
      exemptionToTs: ["", Validators.required],
      deliveryDelayType: ["", Validators.required],
      remarks: ["", Validators.required],
    });
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  cancel() {
    this.dialogRef.close();
  }
  submit() {
    if (this.form.valid) {
      var step3 = {
        id: JSON.parse(this.data),
        acNo: "",
        cityId: null,
        branchId: null,
        ifsc: "",
        dbtSchemeId: null,
        dbtComponentId: null,
        dbtProductId: null,
        dbtProductInfoId: null,
        dbtManufacturerId: null,
        dbtDealerId: null,
        eventType:this.eventEnum.RequestforExemption,
        bankId: null,
        transactionType: 0,
        paymentTs: null,
        receiptNumber: "",
        productCost: 0,
        gstPercentage: 0,
        subsidyAmount: 0,
        totalCost: 0,
        paymentAmount: 0,
        engineNumber: "",
        chassisNumber: "",
        registrationNumber: "",
        deliveryTs: null,
        attachment: null,
        exemptionToTs: this.form.value.exemptionToTs,
        deliveryDelayType: this.form.value.deliveryDelayType,
        remarks: this.form.value.remarks,
      };
      this.farmerService.farmerSave(step3).subscribe((res) => {
        if (res && res.isSuccess) {
          this.dialogRef.close();
          this.alertService.success(
            "Excemption Request Saved Successfully"
          );
          this.router.navigate(["/farmer"]);
        }
      });
    } else {
      this.validateFormControl();
    }
  }
}
